.wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}

.late {
  background: var(--color-feedback-warning-200);
  padding: 2px;
  border-radius: 2px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL2NvbW1vbi9jb21wb25lbnRzL2ludGVybmFsL1RpbWVSYW5nZVN0YXR1cyIsInNvdXJjZXMiOlsiVGltZVJhbmdlU3RhdHVzLm1vZHVsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi53cmFwcGVyIHtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZ2FwOiA0cHg7XG59XG5cbi5sYXRlIHtcbiAgYmFja2dyb3VuZDogdmFyKC0tY29sb3ItZmVlZGJhY2std2FybmluZy0yMDApO1xuICBwYWRkaW5nOiAycHg7XG4gIGJvcmRlci1yYWRpdXM6IDJweDtcbn1cbiJdfQ== */